import React from 'react'
// libs
import styled from 'styled-components'
// components
import PlanTypeForm from './Form'
// constants
import { OBJECT_ENTITY_NAMES } from 'constants/objects'
// types
import { IPlanType } from 'types/graphql'
// utils
import orderBy from 'lodash/orderBy'
import { getOptionFromData, getOptionFromValue } from 'utils/form'

const FormWrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  width: inherit;

  > div {
    padding-bottom: 20px;
  }
`

interface Props {
  planType: IPlanType
}

const PlanTypeEdit: React.FC<Props> = ({ planType }) => {
  const getInitialValues = () => {
    if (!planType) return {}

    return {
      active: planType.active,
      color: planType.color,
      levels: orderBy(planType.levels, 'position').map(({ id, description, color, typeOptions }) => ({
        id,
        description: description || OBJECT_ENTITY_NAMES.OBJECTIVE,
        color,
        typeOptions: (typeOptions || []).map(({ id, label }) => ({ id, label }))
      })),
      code: planType.code,
      description: planType.description,
      allowNesting: planType.allowNesting,
      maximumNestedLevelsCount: getOptionFromValue(planType.maximumNestedLevelsCount),
      objectiveOwnerObjectSecurity: getOptionFromData(planType.objectiveOwnerObjectSecurity),
      objectiveMemberObjectSecurity: getOptionFromData(planType.objectiveMemberObjectSecurity),
      actionOwnerObjectSecurity: getOptionFromData(planType.actionOwnerObjectSecurity),
      actionMemberObjectSecurity: getOptionFromData(planType.actionMemberObjectSecurity),
      kpiOwnerObjectSecurity: getOptionFromData(planType.kpiOwnerObjectSecurity),
      kpiMemberObjectSecurity: getOptionFromData(planType.kpiMemberObjectSecurity),
      planOwnerObjectSecurity: getOptionFromData(planType.planOwnerObjectSecurity),
      planMemberObjectSecurity: getOptionFromData(planType.planMemberObjectSecurity)
    }
  }

  return (
    <FormWrapper>
      <PlanTypeForm planTypeId={planType.id} initialValues={getInitialValues()} />
    </FormWrapper>
  )
}

export default PlanTypeEdit
